import React from 'react'
import propTypes from 'prop-types'
import classNames from 'classnames'
import get from 'lodash/get'
import { observer } from 'mobx-react'

const TextArea = ({ field, form, label, ...props }) => {
  const error = get(form.touched, field.name) && get(form.errors, field.name)
  const groupClasses = classNames({
    'expert-form__input-group': true,
    'expert-form__input-group--error': error
  })
  const wrapperClasses = classNames({
    'expert-form__input-wrapper': true,
    'expert-form__input-wrapper--error': error
  })
  const fieldValue = get(form.values, field.name)

  const inputField = (
    <div className={wrapperClasses}>
      <textarea
        className='expert-form__input'
        {...field}
        {...props}
        value={fieldValue || ''}
        rows='5'
      />
      <div className='expert-form__input-error'>{error}</div>
    </div>
  )

  if (!label) {
    return inputField
  }

  return (
    <div className={groupClasses}>
      <label className='expert-form__label'>{label}</label>
      {inputField}
    </div>
  )
}

TextArea.propTypes = {
  field: propTypes.shape({
    name: propTypes.string
  }).isRequired,
  form: propTypes.object,
  label: propTypes.string,
  noLabel: propTypes.bool
}

export { TextArea }
export default observer(TextArea)
